import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, FormBuilder } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NguiAutoCompleteModule } from '@ngui/auto-complete';
import { DispValidationComponent } from './common/components/dispvalidation.component';
import { TranslatePipe } from '../translate';
import { CustomFormsModule } from 'ng2-validation';
import { PermissionDirective } from './common/directives/menu-permission.directive';
import { MultiCheckboxComponent, ChkChecked, FilterPipe, OrderByPipe } from './common/components/multicheckbox';
@NgModule({
  imports: [CommonModule, CustomFormsModule, RouterModule, NguiAutoCompleteModule],
  declarations: [TranslatePipe, DispValidationComponent, PermissionDirective, MultiCheckboxComponent, ChkChecked, FilterPipe, OrderByPipe],
  providers: [FormBuilder],
  exports: [TranslatePipe, DispValidationComponent, CommonModule, FormsModule, CustomFormsModule, PermissionDirective, MultiCheckboxComponent, ChkChecked, FilterPipe, OrderByPipe, NguiAutoCompleteModule]
})
export class SharedModule {
  constructor() {
  }
}